// extracted by mini-css-extract-plugin
export default {"root":"DT7H69","wired":"nCDQ7e"};